<template>
  <div>
    <div class="vx-row">
      <h1 class="p-3 mb-3">Lastniki parkirnih mest</h1>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <DateSelect
            @search-clicked="handleSearchClicked"
            :dateObject="dateObject"
          ></DateSelect>
        </vx-card>
      </div>
    </div>
    <vs-divider color="light" />
    <Chart
      title="Najemniki parkirnih mest"
      :options="pieChart.options"
      :series="pieChart.series"
      type="pie"
      :topLabel="topLabelText"
      @minimum-number-changed="handleMinimumNumberChanged"
    ></Chart>

    <vx-card>
      <vs-table stripe :data="data" search>
        <template slot="thead">
          <vs-th sort-key="PartnerNaziv">Naziv</vs-th>
          <vs-th sort-key="Kolicina">Količina</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="(tr, index) in data">
            <vs-td>{{ data[index].PartnerNaziv }}</vs-td>
            <vs-td>{{ data[index].Kolicina }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>
<script>
import DateSelect from "../components/DateSelect";
import VueApexCharts from "vue-apexcharts";
import Chart from "../charts/Chart";
export default {
  components: { DateSelect, VueApexCharts, Chart },

  computed: {
    data() {
      return this.$store.state.data.data.slice();
    },
    topLabelText() {
      let dFrom = this.$moment(this.dateObject.dateFrom).format("DD.MM.YYYY");
      let dTo = this.$moment(this.dateObject.dateTo).format("DD.MM.YYYY");
      return `Za izbrano obdobje ${dFrom} - ${dTo}`;
    },
  },
  data() {
    return {
      pieChart: {
        options: {
          chart: {
            height: 1000,
            width: 1000,
            animations: {
              enabled: true,
            },
          },
          legend: {
            position: "right",
            verticalAlign: "top",
          },
          dataLabels: {
            enabled: false,
            position: "bottom",
          },
          xaxis: {
            categories: [],
          },
        },

        series: [
          {
            name: "",
            data: [],
          },
        ],
      },
      dateObject: {
        dateFrom: new Date(),
        dateTo: new Date(),
      },
      minimumNumber: 5,
    };
  },

  methods: {
    async handleSearchClicked() {
      await this.loadData();
    },
    handleMinimumNumberChanged(value) {
      this.minimumNumber = value;
      this.prepareData(false);
    },
    async loadData() {
      let payload = {
        type: "RAC02",
        dateFrom: await this.$moment(this.dateObject.dateFrom).format(
          "YYYY-MM-DD"
        ),
        dateTo: await this.$moment(this.dateObject.dateTo).format("YYYY-MM-DD"),
      };
      await this.$store.dispatch("data/fetchData", payload);
      this.prepareData();
    },

    prepareData(animateGraph = true) {
      let categories = [];
      let seriesData = [];

      let categoriesOtherCounter = 0;
      let seriesDataOther = 0;

      this.data.forEach((el) => {
        if (el.Kolicina > this.minimumNumber) {
          seriesData.push(el.Kolicina);
          categories.push(el.PartnerNaziv);
        } else {
          categoriesOtherCounter++;
          seriesDataOther += el.Kolicina;
        }
      });

      if (categoriesOtherCounter != 0) {
        categories.push("Drugo");
        seriesData.push(seriesDataOther);
      }

      var graphData = {
        options: {
          labels: categories,
          chart: {
            animations: {
              enabled: animateGraph,
            },
          },
        },
        series: seriesData,
      };

      this.pieChart = graphData;
    },
  },

  async mounted() {
    this.$vs.loading();
    try {
      this.$vs.loading();

      await this.loadData();
    } catch (error) {
      this.$vs.notify({
        title: "Napaka pri nalaganju podatkov!",
        text: error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
      });
    } finally {
      this.$vs.loading.close();
    }
  },
};
</script>
